export default (words: number | null | undefined): string => {
  if (!words) {
    return null;
  }

  const WORDS_PER_MINUTE = 200;

  const timeInMinutes = Math.floor(words / WORDS_PER_MINUTE);
  return timeInMinutes > 1 ? `${timeInMinutes} min` : '1 minute';
};
